import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5fe4ef64"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h5", null, "Jobs: Running/Completed", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_JobManager = _resolveComponent("JobManager");
    return (_openBlock(), _createElementBlock("span", null, [
        _hoisted_1,
        _createVNode(_component_JobManager)
    ]));
}
